// extracted by mini-css-extract-plugin
export default {"dataRow":"styles_dataRow__AHkUo","dataColunmTitle":"styles_dataColunmTitle__gFhaI","dataColunmInfo":"styles_dataColunmInfo__WvEMQ","nenhumDado":"styles_nenhumDado__uKasg"};